import Axios from "@app/api/axios";

const verifyRegistrationService = async (token, data) =>
  Axios.put(`email/verify/${token}`, data);

export default verifyRegistrationService;
